import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1n": "#007E31",
    "col2d": "#86DE00",
    "col2l": "#CAFF7B"
}
function ObjFoo069({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    d="M54.55 27.25q0-11.2-7.95-19.25-8.05-8-19.35-8Q16.05 0 8 8q-8 8.05-8 19.25 0 11.3 8 19.35 8.05 7.95 19.25 7.95 11.3 0 19.35-7.95 7.95-8.05 7.95-19.35M103.2 46.6q8-8.05 8-19.35 0-11.2-8-19.25-8.05-8-19.3-8T64.6 8q-3.25 3.25-5.15 7.05-1.3 2.65-2.05 5.55-.75 3.15-.75 6.65 0 3.5.75 6.7.75 2.95 2.05 5.65 1.9 3.75 5.15 7 8.05 7.95 19.3 7.95t19.3-7.95z"
                    id="ObjFoo069__Symbol_168_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2d}
                    d="M6.75 39.6q6.75 6.75 16.2 6.75 9.6 0 16.3-6.75 6.8-6.75 6.8-16.3 0-9.5-6.8-16.25-6.7-6.7-16.3-6.7-9.45 0-16.2 6.7Q0 13.8 0 23.3q0 9.55 6.75 16.3M102.3 23q0-9.5-6.75-16.25Q88.85 0 79.25 0 69.7 0 63 6.75 56.25 13.5 56.25 23q0 9.6 6.75 16.3 6.7 6.8 16.25 6.8 9.6 0 16.3-6.8 6.75-6.7 6.75-16.3z"
                    id="ObjFoo069__Symbol_167_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2l}
                    d="M48.3 24.1q0-9.95-7.1-17.05Q34.15 0 24.1 0 14.15 0 7.05 7.05 0 14.15 0 24.1q0 10.05 7.05 17.1 7.1 7.1 17.05 7.1 10.05 0 17.1-7.1 7.1-7.05 7.1-17.1m-6.5-12.15q2.1 2.55 1.4 6.45-1.05 3.85-4.4 6.6-1.75 1.5-3.65 2.3-4.2 2-4.7 6.7-.15 1.2-.45 2.5-1.2 4.25-4.2 6.65-3.1 2.5-6.25 1.6-3.35-.85-4.7-4.6-1.55-3.5-.4-7.9.1-.35.25-.7.6-5.05-2.1-7.7-.8-.55-1.45-1.25-3.1-3.1-3.7-7.1-.55-3.8 1.85-6.15 2.3-2.4 6.2-1.9 3.5.65 6.5 3.3 3.65 2.7 8 .85 2.65-1.8 5.8-1.95 3.8-.25 6 2.3m63.1 12.2q0-10-7.1-17.1Q90.75 0 80.75 0t-17.1 7.1q-7.05 7.05-7.05 17.05t7.05 17.05q7.1 7.1 17.1 7.1 10 0 17.05-7.05 7.1-7.1 7.1-17.1m-13.2-9.7q-.15 2.25-.95 4.15-1.5 4.4 1.4 8.1.75.95 1.45 2.05 2.15 3.85 1.75 7.65-.4 4-3.3 5.65-2.95 1.7-6.6.05-3.55-1.4-5.85-5.35-.15-.3-.3-.7-3.15-3.95-7-3.9-.85.15-1.85.15-4.35-.05-7.65-2.45-3-2.3-3.05-5.65-.05-3.35 3.15-5.75 2.9-2 6.8-2.2 4.55-.75 6.3-5.1.65-3.15 2.8-5.5 2.45-2.85 5.8-2.6 3.3.3 5.5 3.6 2.05 3.45 1.6 7.8z"
                    id="ObjFoo069__Symbol_166_0_Layer0_0_FILL"
                />
                <path
                    fill="#F9FFEE"
                    d="M156.1 153.25q-2.55-.45-4.05 1.05-1.75 1.55-1.75 4.05.1 2.5 2.25 4.8 2.2 2.2 4.7 2.65 2.65.75 4.45-.65 1.6-1.6 1.5-4.4-.3-2.5-2.25-4.6-2.05-2.3-4.85-2.9m7.65 30.9q1.95-1.75 2.95-5 1.05-3 0-5.65-.55-3-2.4-3.7-1.9-.8-4.1 1.05-1.95 1.5-2.85 4.4-1.05 3.55-.3 6.4.75 2.4 2.7 3.25 2.05.85 4-.75m13.6-28.1q-2.1-.75-4.9.5-2.85 1.35-4.75 4-1.6 2.25-.9 4.3.45 2.2 2.4 2.75 2.5.7 5.75-.8 2.8-1.4 4-3.75.65-.75 1-1.25 1.1-1.9.65-3.4-.45-1.25-1.65-2-.7-.25-1.6-.35z"
                    id="ObjFoo069__Layer1_0_FILL"
                />
                <path
                    fill="#F9FFEE"
                    d="M220.9 169.8q-1.9-.85-4.1 1.05-1.95 1.5-2.85 4.4-1.05 3.55-.35 6.4.8 2.35 2.75 3.25 2.05.85 4-.8 1.95-1.7 2.95-5 1.05-3 0-5.65-.6-3-2.4-3.65m-3.35-13.65q-2.05-2.35-4.9-2.9-2.55-.5-4.05 1.05-1.7 1.55-1.7 4.05.1 2.5 2.2 4.8 2.25 2.2 4.75 2.65 2.65.7 4.45-.65 1.6-1.65 1.5-4.45-.3-2.45-2.25-4.55m18 .25q-.75-.25-1.6-.4-2.15-.7-4.85.5-2.9 1.4-4.8 4-1.65 2.3-.9 4.35.45 2.15 2.35 2.7 2.55.75 5.8-.75 2.8-1.4 4-3.8.65-.7 1-1.2 1.05-1.9.65-3.4-.5-1.25-1.65-2z"
                    id="ObjFoo069__Layer1_1_FILL"
                />
            </defs>
            <use
                xlinkHref="#ObjFoo069__Symbol_168_0_Layer0_0_FILL"
                transform="translate(136.9 139.6)"
                id="ObjFoo069__col1n"
            />
            <use
                xlinkHref="#ObjFoo069__Symbol_167_0_Layer0_0_FILL"
                transform="translate(141.3 143.6)"
                id="ObjFoo069__col2d"
            />
            <use
                xlinkHref="#ObjFoo069__Symbol_166_0_Layer0_0_FILL"
                transform="translate(140.1 142.75)"
                id="ObjFoo069__col2l"
            />
            <use
                xlinkHref="#ObjFoo069__Layer1_0_FILL"
                transform="translate(0 -.1)"
            />
            <use
                xlinkHref="#ObjFoo069__Layer1_1_FILL"
                transform="matrix(.7071 -.7071 .7071 .7071 -53.4 205)"
            />
        </g></g>
    )
}
export default ObjFoo069
